<ion-list lines="none" class="w-full flex flex-col gap-4 py-4">
  <ion-item class="input-label">
    <ion-input
      type="text"
      fill="outline"
      label="Texte du titre"
      label-placement="floating"
      color="primary"
      [(ngModel)]="titleText"
      (ionChange)="onInputChange()"
    ></ion-input>
  </ion-item>
</ion-list>
